import React from 'react';
import classNames from 'classnames';
import styles from './DualViewerToolbar.scss';
import { __ } from '../../../../core/utils';
import Tooltip from '../../../../components/Tooltip';

const Button = ({
  id,
  icon: Icon,
  onClick,
  extraClass,
  active,
  onDoubleClick,
  seeMore,
  label,
}) => (
  <Tooltip
    placement='left'
    text={
      <span
        className={styles.thumbPreview}
        style={{
          width: seeMore ? '200px' : 'unset',
          display: 'flex',
        }}
      >
        {!seeMore ? label : `${label}\n${__('Click to see more options')}`}
      </span>
    }
    html={true}
    dark={true}
  >
    <div
      key={id}
      className={classNames(
        styles.icon,
        extraClass && extraClass.map((cls) => styles[cls]),
        active && styles.active
      )}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <Icon />
    </div>
  </Tooltip>
);

export default Button;
